import React from 'react';
import VerticalAlign from '@/v2/components/layouts/VerticalAlign';
import VideoControllerUtils from '@/v2/components/controllers/VideoController/VideoControllerUtils';
import Video from '../Video';

const propTypes = VideoControllerUtils.GetComponentPropTypes();
const defaultProps = VideoControllerUtils.GetComponentDefaultProps();

class VideoScroll extends React.Component {
    constructor(props) {
        super(props);

        this.extendedProps = { ...this.props };
        this.extendedProps.options.manualPlayback = true;
    }

    render() {
        return (
            <div className="InteractionVideoScroll">
                <VerticalAlign>
                    <Video {...this.extendedProps} />
                </VerticalAlign>
            </div>
        );
    }
}

VideoScroll.propTypes = propTypes;
VideoScroll.defaultProps = defaultProps;

export default VideoScroll;
